<template>
  <div>
    <v-alert
      color="orange"
      justify-center
      v-if="!supplierHaveProduct()"
      :value="true"
      type="error"
      transition="scale-transition"
    >
      The Supplier {{ contract.supplier_company_name }} is not selling any
      product.
    </v-alert>

    <v-dialog v-model="showScoreCostDialog" width="600" lazy>
      <scoreCostSupplier
        @closeBillDialog="closeBillDialog"
        :editedScoreCost="editedScoreCost"
      />
    </v-dialog>

    <v-dialog v-model="showBankInvoiceDialog" width="600" lazy>
      <invoiceShow
        @closeBillDialog="closeBillDialog"
        :showedBankInvoice="editedBankInvoice"
      />
    </v-dialog>

    <v-layout pa-4 column wrap justify-center v-if="supplierHaveProduct()">
      <v-flex xs12>
        <productTrades :previsional="false" />
      </v-flex>

      <v-flex
        my-3
        v-if="contractHaveProductTrades() && this.getNetWeightProducts() <= 0"
      >
        <v-layout row wrap justify-center>
          <span class="error--text">
            <v-icon class="error--text" small>warning</v-icon>Total net weight
            of products should not be null.
          </span>
        </v-layout>
      </v-flex>

      <v-flex
        xs12
        px-0
        my-3
        v-if="contractHaveProductTrades() && this.getNetWeightProducts() > 0"
      >
        <expeditions :previsional="false" />
      </v-flex>

      <v-flex xs12 my-2>
        <v-layout row justify-center>
          <v-btn depressed @click="generateRealScore" color="#d21933">
            <v-icon small color="white" class="pr-2">timeline</v-icon>
            <span style="color: white;">Generate real score</span>
          </v-btn>
        </v-layout>
      </v-flex>

      <v-flex px-0>
        <v-layout column v-if="realScoreGenerated()">
          <v-layout column>
            <v-flex my-2>
              <scoreCosts :previsional="false" />
            </v-flex>
          </v-layout>

          <v-flex my-4>
            <totalScore :previsional="false" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import productTrades from "./productTrades";
import expeditions from "./expeditions";
import scoreCosts from "./scoreCosts";
import GENERATE_REAL_SCORE from "../../graphql/contracts/generate_real_score.gql";
import scoreProducts from "../../mixins/scoreProducts";
import totalScore from "./totalScore";
import invoiceShow from "../accounting/invoices/invoiceShow";
import scoreCostSupplier from "./scoreCostSupplier";

export default {
  name: "realScore",
  mixins: [scoreProducts],
  components: {
    invoiceShow,
    expeditions,
    productTrades,
    scoreCosts,
    totalScore,
    scoreCostSupplier
  },
  data() {
    return {
      //showBankInvoiceDialog: false,
      editedItem: null,
      showScoreCostDialog: false,
      previsional: false
    };
  },
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "real_expeditions",
      "previsional_expeditions",
      "editedBankInvoice",
      "editedScoreCost",
    ]),
    showBankInvoiceDialog: {
      set(value) {
        this.$store.commit("contractStore/showBankInvoiceDialog", {
          value: value,
        });
      },
      get() {
        return this.$store.state.contractStore.showBankInvoiceDialog;
      },
    },
  },
  watch: {
    editedScoreCost() {
      if (this.editedScoreCost && this.editedScoreCost.id)
        this.showScoreCostDialog = true;
    },
    showScoreCostDialog() {
      if (!this.showScoreCostDialog) {
        this.$store.commit("contractStore/showScoreCostSupplier", {
          value: false,
          editedItem: {},
        });
      }
    }
  },
  methods: {
    closeBillDialog() {
      this.showScoreCostDialog = false;
    },
    realScoreGenerated() {
      return true
    },
    generateRealScore() {
      this.sendMutation("generated", "score", GENERATE_REAL_SCORE, {
        id: this.contract.id,
      });
    },
  },
};
</script>
